import { VictimFormData } from "#root/pages/VTracker/AllVictims/VictimForm";
import { OFFLINE_OPERATIONS, OfflineOperationType } from '#root/utils/offlineOperations';
import { VictimOperations } from '#root/hooks/useVictimOperations';
import { GeneralContactOperations } from "#root/hooks/useGeneralContactOperations";
import { ContactFormData } from "#root/pages/VTracker/AllContacts/ContactForm";

export type Operations = {
    victimOperations?: VictimOperations;
    generalContactOperations?: GeneralContactOperations;
};

export type OfflineOperationData = {
    type: OfflineOperationType;
    payload: any;
};

export type OfflineOperationHandler = (data: any, operations: Operations) => Promise<any>;

// Registry of operation handlers
const operationHandlers: Partial<Record<OfflineOperationType, OfflineOperationHandler>> = {
    [OFFLINE_OPERATIONS.VICTIM.CREATE]: async (data: VictimFormData, { victimOperations }) => {
        if (!victimOperations) throw new Error('Create victim operation not provided');
        return victimOperations.createVictim(data);
    },
    [OFFLINE_OPERATIONS.CONTACT.CREATE]: async (data: ContactFormData, {generalContactOperations}) => {
        if (!generalContactOperations) throw new Error('Create general contact operation not provided');
        return generalContactOperations.createGeneralContact(data);
    }
};

export const executeOperation = async (type: OfflineOperationType, data: any, operations: Operations) => {
    const handler = operationHandlers[type];
    if (!handler) {
        throw new Error(`No handler found for operation type: ${type}`);
    }
    return handler(data, operations);
};
